// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const AuthErrorModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-authErrorModalContainer" */ "./AuthErrorModalContainer")).then((bundle)=>{
        return {
            default: bundle.AuthErrorModalContainer
        };
    });
export const LazyAuthErrorModalContainer = /*#__PURE__*/ lazy(AuthErrorModalContainerLazyLoader);
